import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Inscription, Preloader, useResponsive, WalletIcon } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { CardStatusActionWrap } from '../ChangeStatusCardModal.styles';

interface CardAccountsAccessCardProps {
  loadingButton: boolean;
  onOpenManageAccountAccessModal: () => void;
}

const CardAccountsAccessCard: React.FC<CardAccountsAccessCardProps> = ({
  loadingButton,
  onOpenManageAccountAccessModal,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const accountsAccessLabel = t('Accounts Access');

  return (
    <CardStatusActionWrap
      $isMobile={isMobile}
      $width="100%"
      $height={isMobile ? undefined : '96px'}
      $isCompact
      background="canvas"
      round="container1Round"
      justify="between"
      $withBorderShadow
    >
      <Box
        direction={isMobile ? 'column' : 'row'}
        align={isMobile ? 'stretch' : 'center'}
        gap={isMobile ? 'spacing24' : 'spacing12'}
        width="100%"
      >
        <Box direction="row" align="flex-start" gap={isMobile ? 'spacing12' : undefined}>
          <WalletIcon size="48px" color="iconAccent" />
          <Box justify="center" margin={{ left: isMobile ? undefined : 'spacing16' }}>
            <Inscription color="textBody" weight="bold" lineHeight="20px">
              {accountsAccessLabel}
            </Inscription>
            <Inscription color="textBody" lineHeight="20px">
              {t('Lock or unlock individual accounts. The account status will be reflected on all cards.')}
            </Inscription>
          </Box>
        </Box>
        <AppButton
          testId="card-accounts-access-card_button"
          buttonType="primary"
          width={isMobile ? '100%' : '180px'}
          style={{ height: '40px', paddingInline: theme.spacings.spacing12 }}
          disabled={loadingButton}
          onClick={onOpenManageAccountAccessModal}
        >
          {loadingButton ? (
            <Box width="100%" align="center">
              <Preloader color="white" />
            </Box>
          ) : (
            t('Lock/Unlock Accounts')
          )}
        </AppButton>
      </Box>
    </CardStatusActionWrap>
  );
};

export default CardAccountsAccessCard;
